import Component from "../core/Component.js";
import * as DashboardApi from "../../apiCall/dashboard/index.js";
import {DashboardItem} from "./items/index.js";
import {MentionWidget} from "./components/mention-widget/index.js";
import {BookmarkWidget} from "./components/bookmark-widget/index.js";
import {
    clickPopupArea, lnbAreaClick, sortableWidget, putProject, saveSlogan,
    removeChatItem,
} from "./event.js";
import DashboardSettingEvent from "./components/widget-setting/event.js";
import {AlarmWidget} from "./components/alarm-widget/index.js";
import {ProjectContentWidget} from "./components/project-content-widget/index.js";
import {WorkWidget} from "./components/work-widget/index";
import {WIDGET} from "./widgetConstants.js";
import {ChatWidget} from "./components/chat-widget/index.js";
import {ProjectSummaryWidget} from "./components/project-summary-widget/index.js";
import {FileWidget} from "./components/file-widget/index.js";
import {drawSelectSchedule, widgetCalendar} from "./components/calendar-widget/index.js";
import {MemoWidget} from "./components/memo-widget/index.js";
import {MemberWidget} from "./components/member-widget/index.js";
import {ProjectListWidget} from "./components/project-list-widget/index.js";
import {drawFrameList, openSettingPopup} from "./components/widget-setting/index.js";
import {FrequentMemberWidget} from "./components/frequent-member-widget/index.js";
import {WeeklyMyTaskWidget} from "./components/weekly-my-task-widget/index.js";

export let widgetBoard = {}
export {
    checkRefreshTarget,
    checkRefreshProfile,
    removeChatItem,
    putProject,
}

export async function init(isReset) {

    //없을때나 리셋일때만 조회
    if (globalValue.widgetInfo === '' || isReset) {
        await DashboardApi.getApi('defaultWidget', ({USER_ID: _USER_ID, USE_INTT_ID: _USE_INTT_ID}));
        const widgetArr = await DashboardApi.getApi('widgetList');
        globalValue.widgetInfo = widgetArr.WIDGET_REC;
    }

    //이미 관찰중인 옵저버가 있는경우 해제
    widgetBoard?.io?.disconnect();

    //보드영역
    widgetBoard = new WidgetBoard(
        document.querySelector('#dashboardContainer .widget-wrap'),
        globalValue.widgetInfo.filter(v => v.WIDGET_SRNO !== '0' && v.WIDGET_SRNO !== '2')
    )

    setWelcomeMessageAndDate()
}

export function closeFilter() {
    $('.widget-filter-mini-pop').addClass('d-none');
}

export function closeWidgetMore() {
    $('.widget-button-popup').fadeOut(100)
}

export class WidgetBoard extends Component {

    setup() {
        //위젯 컴포넌트 보관용
        this.$state = {
            projectContent: [],
            projectSummary: [],
            memo: [],
            file: []
        }
        this.$refresh = [] //위젯 갱신여부
        $('.dash-skeleton-wrap').css('display', 'none');
        $('#dashboardContainer').removeClass('dash-skeleton')
    }

    template() {
        return `<ul id="dashboardWrap" class="js-widget-wrap widget-list">
                     ${this.$props.map(DashboardItem).join('')}
                </ul>
                <div class="js-button-widget-add widget-prj-empty" 
                     style="display: ${this.$props.length > 0 ? 'none' : ''}">
                    <p>
                        <button class="button-project-select"></button>${i18next.t(main.addWidget)}
                    </p>
                </div>`

    }

    async mounted() {
        await this.$props.forEach(v => {
            setWidgetModule.bind(this)(v);
        })
        this.dashboardObserver();

        //임시로직
        NewBadge.showNewBadgePopup({
            $target: $('.button-widget-set'),
            $container: $('.dash-right-conts'),
            contents: {
                title: '신규 위젯 출시',
                contentsTxt: '새롭게 추가된 위젯을<br>확인해 보세요!',
            },
            customEvent:{
                mouseEnterCallback: () => {
                    $('.button-widget-set').hover()
                },
                mouseLeaveCallback: () => {
                    $('.button-widget-set').blur()
                }
            }
        })
    }

    setEvent() {
        $('#dashboardWrap').off('click').on('click', (e) => clickPopupArea(e));

        //위젯을 추가해보세요
        $('.js-button-widget-add').off('click').on('click', () => {
            openSettingPopup();
            drawFrameList();
        })
        //lnb
        const $slgn = $('.js-user-slogan');
        $('.lnb-wrap').off('click').on('click', lnbAreaClick);
        $slgn.off('blur').off('keyup')
            .on('blur', saveSlogan)
            .on('keyup', (e) => KeyCheck.isKey(e, "ENTER") && $slgn.trigger('blur'))

        //widget drag 이벤트 부분
        $('.widget-list>li').off('dragstart').on('dragstart', (e) => {
            $(e.target).addClass('widget-dragging');
        }).off('dragend').on('dragend', (e) => {
            $(e.target).removeClass('widget-dragging');
        });
        DashboardSettingEvent.init()
        sortableWidget();
    }

    // 대시보드가 화면에 있는지를 체크하고 갱신하기 위한 IntersectionObserver 를 등록.
    dashboardObserver() {
        this.io = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                // 관찰 대상이 viewport 안에 들어온 경우
                if (entry.intersectionRatio > 0) {
                    Mutil.clog('Intersecting in Dashboard')
                } else if (!entry.isIntersecting) {
                    // 관찰 대상의 교차 상태가 false 일 (보이지 않는) 경우
                    Mutil.clog('No intersecting in Dashboard')
                    // widgetBoard = {}
                }
            })
        })

        // 관찰할 대상을 선언하고, 해당 속성을 관찰시킴.
        const $d = document.getElementById('dashboardContainer');
        this.io.observe($d);
    }

    checkRefreshWidget() {
        // widgetBoard.refreshTimer = setInterval(() => {
        //     widgetBoard.$refresh.forEach((v, i) => {
        //         widgetBoard.$state[v.widgetName]?.refresh(v);
        //         widgetBoard.$refresh.splice(i, 1)
        //     })
        // }, 2000)
    }

}

export function setWidgetModule(v) {
    switch (v.WIDGET_SRNO) {
        case WIDGET.REQUEST_TASK.SRNO:
            this.$state.requestWork =
                new WorkWidget(
                    document.querySelector('#dashboardWrap .widget-request-work'),
                    {
                        ...v,
                        FILTER_GB: '2',
                        keySrno: 'COLABO_COMMT_SRNO',
                        isDataDrivenRendering: true,
                    }
                );
            break;
        case WIDGET.MY_TASK.SRNO:
            this.$state.myWork = new WorkWidget(
                document.querySelector('#dashboardWrap .widget-my-work'),
                {
                    ...v,
                    FILTER_GB: '1',
                    keySrno: 'COLABO_COMMT_SRNO',
                    isDataDrivenRendering: true,
                });
            break;
        case WIDGET.MY_SCHEDULE.SRNO:
            widgetCalendar();
            this.$state.calendar = {
                setup() {
                    drawSelectSchedule();
                }
            };
            break;
        case WIDGET.BOOKMARK.SRNO:
            this.$state.bookmark = new BookmarkWidget(
                document.querySelector('.widget-bookmark .widget-article-list'),
                {
                    ...v,
                    ...WIDGET.BOOKMARK.API,
                    keySrno: WIDGET.BOOKMARK.INDEX_KEY_SRNO
                });
            break;
        case WIDGET.MENTION.SRNO:
            this.$state.mention = new MentionWidget(
                document.querySelector('.widget-mention .widget-article-list'),
                {
                    ...v,
                    ...WIDGET.MENTION.API,
                    keySrno: WIDGET.MENTION.INDEX_KEY_SRNO
                });
            break;
        case WIDGET.PROJECT.SRNO:
            this.$state.projectContent.push({
                key: v.WIDGET_USER_SRNO,
                val: new ProjectContentWidget(document.getElementById(v.WIDGET_USER_SRNO),
                    {
                        ...v,
                        ...WIDGET.PROJECT.API,
                        ...WIDGET.PROJECT.SETTING,
                        keySrno: WIDGET.PROJECT.INDEX_KEY_SRNO
                    })
            });
            break;
        case WIDGET.REPORT.SRNO:
            this.$state.projectSummary.push({
                key: v.WIDGET_USER_SRNO,
                val: new ProjectSummaryWidget(document.getElementById(v.WIDGET_USER_SRNO),
                    {
                        ...v,
                        ...WIDGET.REPORT.API,
                        ...WIDGET.REPORT.SETTING,
                        keySrno: WIDGET.REPORT.INDEX_KEY_SRNO
                    })
            });
            break;
        case WIDGET.FILE.SRNO:
            this.$state.file.push({
                key: v.WIDGET_USER_SRNO,
                val: new FileWidget(document.getElementById(v.WIDGET_USER_SRNO),
                    {
                        ...v,
                        ...WIDGET.FILE.API,
                        ...WIDGET.FILE.SETTING,
                        keySrno: WIDGET.FILE.INDEX_KEY_SRNO
                    })
            });
            break;
        case WIDGET.UNREAD.SRNO:
            this.$state.unread = new AlarmWidget(
                document.querySelector('.widget-alarm .widget-article-list'),
                {
                    ...v,
                    ...WIDGET.UNREAD.API,
                    keySrno: WIDGET.UNREAD.INDEX_KEY_SRNO
                });
            break;
        case WIDGET.CHAT.SRNO:
            this.$state.chat = new ChatWidget(
                document.querySelector('.widget-chat .chat-list'), {
                    ...v,
                    isInit: true,
                    ...WIDGET.CHAT.API,
                    keySrno: WIDGET.CHAT.INDEX_KEY_SRNO
                });
            break;
        case WIDGET.MEMBER.SRNO:
            this.$state.member = new MemberWidget(
                document.querySelector(`.widget-my-member[id="${v.WIDGET_USER_SRNO}"] .widget-article-list`), {
                    ...v,
                    isInit: true,
                    keySrno: WIDGET.MEMBER.INDEX_KEY_SRNO,
                    API_KEY: WIDGET.MEMBER.API.API_KEY[Number(v.FIL_END_DT_GUBUN) === 3 ? 0 : 1],
                    RECORD: WIDGET.MEMBER.API.RECORD[Number(v.FIL_END_DT_GUBUN) === 3 ? 0 : 1]
                });
            break;
        case WIDGET.FREQUENT_MEMBER.SRNO:
            this.$state.frequentMember = new FrequentMemberWidget(
                document.querySelector(`.widget-frequent-member[id="${v.WIDGET_USER_SRNO}"] .widget-article-list`), {
                    ...v,
                    isInit: true,
                    keySrno: WIDGET.FREQUENT_MEMBER.INDEX_KEY_SRNO,
                    API_KEY: WIDGET.FREQUENT_MEMBER.API.API_KEY,
                    RECORD: WIDGET.FREQUENT_MEMBER.API.RECORD
                });
            break;
        case WIDGET.WEEKLY_MY_TASK.SRNO:
            this.$state.weeklyMyTask = new WeeklyMyTaskWidget(
                document.querySelector(`.widget-weekly-my-task[id="${v.WIDGET_USER_SRNO}"] .widget-article-list`), {
                    ...v,
                    isInit: true,
                    keySrno: WIDGET.WEEKLY_MY_TASK.INDEX_KEY_SRNO,
                    API_KEY: WIDGET.WEEKLY_MY_TASK.API.API_KEY,
                    RECORD: WIDGET.WEEKLY_MY_TASK.API.RECORD
                });
            break;
        case WIDGET.MEMO.SRNO:
            this.$state.memo.push({
                key: v.WIDGET_USER_SRNO,
                val: new MemoWidget(
                    document.querySelector(`.widget-memo[id="${v.WIDGET_USER_SRNO}"] .widget-article-list`), {
                        ...v,
                        isDataDrivenRendering: true,
                        keySrno: 'MEMO_SRNO'
                    }
                )
            });
            break;
        case WIDGET.MY_PROJECT.SRNO:
            this.$state.myProject = new ProjectListWidget(
                document.querySelector(`.widget-my-prj[id="${v.WIDGET_USER_SRNO}"] .widget-article-list`),
                {
                    ...v,
                    ...WIDGET.MY_PROJECT.API,
                    keySrno: WIDGET.MY_PROJECT.INDEX_KEY_SRNO,
                    isInit: true,
                });
            break;
        default:
            break;
    }
}

function findAndRefreshWidget(target, props) {
    if(!widgetBoard.$state) return;

    if (target === WIDGET.MEMO.KEY) {
        //보류
        // if (!props.WIDGET_USER_SRNO || !widgetBoard.$state[target]) return;
        // widgetBoard.$state[target]?.map(v => {
        //     (v.val.$props.WIDGET_USER_SRNO === props.WIDGET_USER_SRNO) && v.val.setup({
        //         isDataDrivenRendering: true, isInit: true
        //     })
        // })
    } else if (widgetBoard.$state[target] && typeof widgetBoard.$state[target]?.setup === 'function') {
        widgetBoard.$state[target].setup({
            isDataDrivenRendering: true, isInit: true
        })
    } else if (props.COLABO_SRNO) {
        widgetBoard.$state[target]?.map(v => {
            (v.val.$props.COLABO_SRNO === props.COLABO_SRNO) && v.val.setup({
                isDataDrivenRendering: true,
                isInit: true
            })
        })
    }
}

function checkRefreshTarget(props) {
    const {WIDGET_TYPE} = props

    WIDGET_TYPE.map(v => {
        for (const i in WIDGET) {
            if (WIDGET[i].SRNO === v) findAndRefreshWidget(WIDGET[i].KEY, props)
        }
    })
}

function checkRefreshProfile(props) {
    $('.js-user-slogan').val(props.SLGN)
    $('.dashboard-profile-name').text(getWelcomeMessage(props.FLNM))
    $('.lnb-wrap').css('display', '');
}

function getWelcomeMessage(userNm) {
    const date = dayjs().toDate();
    const hour = date.getHours();
    let msg = "";
    if (hour < 12 && hour >= 5) {
        msg = main.goodMorning;
    } else if (hour >= 12 && hour < 21) {
        msg = main.goodAfternoon;
    } else {
        msg = main.goodNight;
    }
    return i18next.t(msg, {
        val: Mutil.n2v(userNm),
        interpolation: { escapeValue: false }
    });
}

function setWelcomeMessageAndDate(){
    $('.dashboard-profile-name').text(getWelcomeMessage(_USER_NM))
    document.getElementById("widget-date").textContent = Time.currentTime('type27');
    $('.lnb-wrap').css('display', '');
}
